import React from 'react';
import { motion } from 'framer-motion';

const Testimonials = ({ socialproofs, variant, className, imageUrl }) => {
  console.log("Testimonials component rendered with variant:", variant, "data:", socialproofs);

  // Add a check if socialproofs is empty or undefined
  if (!socialproofs || socialproofs.length === 0) {
    return <div className={className}>No testimonials available</div>;
  }

  return (
    <div className={className}>
      {variant === 'mobile' ? (
        <>
          <h3 className="text-xl font-bold text-center mb-6">What Our Students Say</h3>
          <div className="space-y-4">
            {socialproofs.map((testimonial, i) => (
              <motion.div 
                key={i}
                whileHover={{ y: -3 }}
                className="bg-white p-4 rounded-lg shadow-md"
              >
                <div className="flex items-center mb-3">
                  <img 
                    src={`${imageUrl}/${testimonial.image}`} 
                    alt={testimonial.name}
                    className="w-10 h-10 rounded-full mr-3"
                    onError={(e) => { e.target.src = '/placeholder-user.png'; }}
                  />
                  <div>
                    <p className="font-semibold">{testimonial.name}</p>
                    <p className="text-sm text-gray-600">{testimonial.designation}</p>
                  </div>
                </div>
                <p className="text-gray-700">"{testimonial.description}"</p>
              </motion.div>
            ))}
          </div>
        </>
      ) : (
        <>
          <h3 className="text-2xl font-bold text-center mb-12">Success Stories From Our Community</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {socialproofs.map((testimonial, i) => (
              <motion.div 
                key={i}
                whileHover={{ y: -5 }}
                className="bg-white p-6 rounded-xl shadow-lg"
              >
                <div className="flex items-center mb-4">
                  <img 
                    src={`${imageUrl}/${testimonial.image}`} 
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full mr-4"
                    onError={(e) => { e.target.src = '/placeholder-user.png'; }}
                  />
                  <div>
                    <p className="font-bold">{testimonial.name}</p>
                    <p className="text-sm text-gray-600">{testimonial.designation}</p>
                  </div>
                </div>
                <p className="text-gray-700">"{testimonial.description}"</p>
              </motion.div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Testimonials;